
import state from './moduleApprovalListState.js'
import mutations from './moduleApprovalListMutations.js'
import actions from './moduleApprovalListActions.js'
import getters from './moduleApprovalListGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
